/** Junta classes ignorando falsy — evita template strings com `${cond ? 'a' : ''}`. */
export const cx = (...classes: Array<string | false | null | undefined | 0>) =>
  classes.filter(Boolean).join(' ');
